import Vue from 'vue'
import { mapState } from 'vuex'
import { GigApplicationStatuses } from '@/constants/gig/gigApplicationStatuses'
import { GigJobStages } from '@/constants/gig/gigJobStages'
import { RootState } from '@/store'

export default Vue.extend({
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    isArchived() {
      return this.application.status === GigApplicationStatuses.ARCHIVED
    },
    isStarted() {
      return !!this.application?.job
    },
    isCompleted() {
      return [GigJobStages.PAYED, GigJobStages.RETURNED, GigJobStages.DISPUTED].includes(this.application?.job?.stage)
    },
  },
})
